import { useContext, useState } from 'react';
import ActionButton from '../../atoms/ActionButton/ActionButton';
import ErrorAlert from '../../atoms/ErrorAlert/ErrorAlert';
import ExpandedUserFullName from '../../atoms/ExpandedUserFullName/ExpandedUserFullName';
import UserFullName from '../../atoms/UserFullName/UserFullName';
import './FriendRequest.scss';
import GlobalVariablesContext from '../../contexts/GlobalVariablesContext';

interface FriendRequestProps {
    id: number;
    userName: string;
    firstName: string;
    lastName: string;
    friendAccepted?: () => void;
}

const FriendRequest = (props: FriendRequestProps) => {

    const { giftsApi } = useContext(GlobalVariablesContext);

    const [accepted, setAccepted] = useState(false);

    const [rejected, setRejected] = useState(false);

    const [error, setError] = useState('');

    const handleAcceptButtonClick = async () => {
        await giftsApi
            .acceptFriendRequest(props.id)
            .then(data => {
                setAccepted(true);
            })
            .catch(error => {
                setError(error.response.data.error);
            });
        if (props.friendAccepted) {
            props.friendAccepted();
        }
    }

    const handleDeclineButtonClick = async () => {
        await giftsApi
            .rejectFriendRequest(props.id)
            .then(data => {
                setRejected(true);
            })
            .catch(error => {
                setError(error.response.data.error);
            });
    }

    return (
        <div className="friend-request">
            <div className="friend-request-content">
                <ExpandedUserFullName userName={props.userName} firstName={props.firstName} lastName={props.lastName} />
                {error && <ErrorAlert title='Cannot Process Response' message={error} />}
                {!accepted && !rejected &&
                    <div className="friend-request-actions">
                        <ActionButton label='Accept' onClick={() => handleAcceptButtonClick()} />
                        <ActionButton label='Decline' variant='red' onClick={() => handleDeclineButtonClick()} />
                    </div>
                }
            </div>
            {accepted && <p>You have accepted the friend request from <UserFullName firstName={props.firstName} lastName={props.lastName} /></p>}
            {rejected && <p>You have rejected the friend request from <UserFullName firstName={props.firstName} lastName={props.lastName} /></p>}
        </div>
    );
}

export default FriendRequest;